export const kinds = [
  { value: 'poradnik', label: 'poradnik' },
  { value: 'ulotka', label: 'ulotka' },
  { value: 'prezentacja multimedialna', label: 'prezentacja multimedialna' },
  {
    value: 'arkusz obserwacyjny dla pracowników poradni na wizyty domowe',
    label: 'arkusz obserwacyjny dla pracowników poradni na wizyty domowe',
  },
  {
    value: 'arkusz obserwacyjny dla rodziców',
    label: 'arkusz obserwacyjny dla rodziców',
  },
  {
    value: 'scenariusz wywiadu z rodzicem',
    label: 'scenariusz wywiadu z rodzicem',
  },
  { value: 'gra', label: 'gra' },
  { value: 'karta pracy', label: 'karta pracy' },
  { value: 'scenariusz', label: 'scenariusz' },
  { value: 'instrukcja', label: 'instrukcja' },
  { value: 'wskazówki', label: 'wskazówki' },
  {
    value: 'materiał wspierający diagnozę',
    label: 'materiał wspierający diagnozę',
  },
  { value: 'skala ICF', label: 'skala ICF' },
]
export const speSubgroups = [
  {
    value: 'DEEP',
    label: 'niepełnosprawność intelektualna w stopniu głębokim',
  },
  {
    value: 'SIGNIFICANT',
    label: 'niepełnosprawność intelektualna w stopniu znacznym',
  },
  {
    value: 'MODERATE',
    label: 'niepełnosprawność intelektualna w stopniu umiarkowanym',
  },
]

export const areas = [
  { value: 'attentionControl', label: 'Procesy kontroli uwagi' },
  {
    value: 'charactersRecognition',
    label: 'Znajomość liter',
  },
  { value: 'cognitiveFlexibility', label: 'Elastyczność poznawcza' },
  { value: 'grammar', label: 'Gramatyka' },
  { value: 'perceptionSpeed', label: 'Szybkość' },
  { value: 'phonology', label: 'Fonologia' },
  { value: 'planning', label: 'Planowanie' },
  { value: 'pragmatics', label: 'Pragmatyka' },
  { value: 'readingDecoding', label: 'Czytanie-dekodowanie' },
  { value: 'readingUnderstanding', label: 'Czytanie-rozumienie' },
  { value: 'reasoning', label: 'Rozumowanie' },
  { value: 'semantics', label: 'Semantyka' },
  { value: 'workMemory', label: 'Pamięć robocza' },
  { value: 'writing', label: 'Pisanie' },
  { value: 'Czytanie i pisanie', label: 'Czytanie i pisanie' },
  { value: 'Komunikacja - ekspresja', label: 'Komunikacja - ekspresja' },
  { value: 'Komunikacja - percepcja', label: 'Komunikacja - percepcja' },
  {
    value: 'Koordynacja wzrokowo-ruchowa i percepcja',
    label: 'Koordynacja wzrokowo-ruchowa i percepcja',
  },
  { value: 'Obsługa IT', label: 'Obsługa IT' },
  { value: 'Pamięć', label: 'Pamięć' },
  {
    value:
      'Rozumowanie (wnioskowanie, planowanie, decydowanie, rozwój pojęciowy, umiejętności matematyczne)',
    label:
      'Rozumowanie (wnioskowanie, planowanie, decydowanie, rozwój pojęciowy, umiejętności matematyczne)',
  },
  { value: 'Uwaga', label: 'Uwaga' },
]

export interface Materials {
  displayedName: string
  filename: string
  id: number
  kind: string
  maxAge: number
  minAge: number
  size: string
  speGroups: string[]
  subAreas: string[]
}
export interface ChangedMaterials {
  alphabet: string
  displayedName: string
  filename: string
  id: number
  kind: string
  maxAge: string
  minAge: string
  size: string
  speGroups: string[]
  subAreas: string[]
}

export type OpenModalProps = {
  open: boolean
}

export type ModalStateProps = {
  recipients: string[]
  materialFilenames: string[]
}

export type DiagnosticModalProps = {
  open: boolean
  examinationId: null | number
}
